import { getMappedColors } from '../colorsMap'
import { getAxisLabelFormatter } from '../formatChartData'
import { ChartData } from '@/Atomic/Organisms/Charts/acBar/dataConverter'
import { getCurrentLocale } from '@/utils/localeMapping'

export function getPieOptionsAndDataV2(data: ChartData, showLegend: boolean) {
  try {
    const { metaData, chartData = [] } = data

    // Extract labels from group titles
    const labels = chartData.map(
      (item) => metaData.properties.groupTitles?.[item.group ?? 0] || '',
    )

    // Extract values
    const series = chartData.map((item) => item.value)

    // Extract colors
    const colors = getMappedColors(
      chartData.map((item) => metaData.colors?.[item.color ?? 0] || ''),
    )

    // Get locale with fallback for Storybook/test environments
    const locale = getCurrentLocale()

    const defaultFormatter = (value: number) =>
      value.toLocaleString(locale, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      })
    const formatValue = getAxisLabelFormatter(
      metaData.properties.yFormat,
      locale,
      defaultFormatter,
    )

    // Extract chart options
    const options = {
      chart: {
        type: 'pie',
      },
      labels: labels,
      series: series,
      legend: {
        show: showLegend,
        position: metaData.legendPosition
          ? (metaData.legendPosition.toLowerCase() as
              | 'bottom'
              | 'top'
              | 'left'
              | 'right')
          : 'bottom',
      },
      yaxis: {
        labels: {
          formatter: formatValue,
        },
      },
      colors: colors,
      tooltip: {
        y: {
          formatter: formatValue,
        },
      },
    }

    return { options: options, data: series }
  } catch (error) {
    console.error(
      'Error processing pie chart data:',
      error instanceof Error ? error.message : 'Unknown error',
    )

    const fallbackOptions = {
      chart: {
        type: 'pie',
      },
      labels: [],
      series: [],
      legend: {
        show: false,
        position: 'bottom' as 'bottom' | 'top' | 'left' | 'right',
      },
      yaxis: {
        labels: {
          formatter: (value: number) => `${value}`,
        },
      },
      colors: [],
      tooltip: {
        y: {
          formatter: (value: number) => `${value}`,
        },
      },
    }

    return { options: fallbackOptions, data: [] }
  }
}
